import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useApp } from '../App';
import { post } from '../data/api';

export default function Login() {
  const navigate = useNavigate();
  const { login, token } = useApp();

  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  if (token) return null; // already logged in — App routing handles redirect

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await post('login', { email, password });
      if (!data.success) { setError(data.error || 'Login failed.'); return; }
      login(data);
      navigate('/dashboard', { replace: true });
    } catch {
      setError('Could not reach the server. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="signup-page">
      <header className="signup-header">
        <div className="signup-logo">mudiaspora.</div>
        <button className="btn btn-ghost btn-sm" onClick={() => navigate('/')}>
          ← Back to home
        </button>
      </header>

      <div className="signup-body">
        <div className="signup-card" style={{ maxWidth: 420 }}>
          <h2 className="signup-card-title">Welcome back</h2>
          <p className="signup-card-sub">Sign in to manage your properties in Kenya.</p>

          {error && (
            <div className="alert alert-error" style={{ marginBottom: 16 }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email address</label>
              <input
                id="email"
                type="email"
                className="form-control"
                placeholder="you@example.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                className="form-control"
                placeholder="••••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-lg btn-full"
              disabled={loading}
            >
              {loading ? 'Signing in…' : 'Sign In →'}
            </button>
          </form>

          <p className="text-muted text-sm" style={{ textAlign: 'center', marginTop: 20 }}>
            Don't have an account?{' '}
            <Link to="/signup" style={{ color: 'var(--green)', fontWeight: 600 }}>
              Create one free
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
